import { IClaimStepModel } from "../types";

/**
 * Default empty model for claim details form
 */
export const CLAIM_EMPTY_MODEL: IClaimStepModel = {
  accident_date: null,
  claim_number: "",
  license_plate: "",
  vin: "",
  driver_first_name: "",
  driver_last_name: "",
  documents: [],
  photos: [],
};
